import { ErrorInfo } from "react";
import { getNRErrorInfo, isEmpty } from "@swiggy-private/js-utils";
import Blaze from "@swiggy-private/blaze.js";
import { isBrowserEnv } from "./bridgeSdk";
import { getSwiggyHeaders } from "./headers";

const eventType = "portal_gamification_frontend";

export const filterHeaders = (swiggyHeaders: Record<string, string | undefined>) => {
    return {
        deviceId: swiggyHeaders?.deviceId || "--",
        tid: swiggyHeaders?.tid || "--",
        userId: swiggyHeaders?.userId || "--",
        platform: swiggyHeaders?.platform || "--",
        appVersionCode: swiggyHeaders?.["version-code"] || "--",
    };
};

export const sendCustomNREvViaBlaze = (
    type: string,
    body: Record<string, string | number>,
    headers: Record<string, string | undefined> | void,
) => {
    const swgyHeaders = headers ? filterHeaders(headers) : {};
    Blaze.recordCustomEvent({
        eventType: eventType,
        type,
        referrer: window.location.href,
        ...body,
        ...swgyHeaders,
    });
};

export const sendCustomNREvWithHeaders = async (type: string, body: Record<string, string | number>) => {
    const swgyHeaders = await getSwiggyHeaders();
    sendCustomNREvViaBlaze(type, body, swgyHeaders);
};

export function getAppHostName() {
    return isBrowserEnv() && !isEmpty(window?.location?.hostname) ? window.location.hostname : "";
}

export function getUserAgent() {
    return isBrowserEnv() && !isEmpty(window?.navigator?.userAgent) ? window.navigator.userAgent : "";
}

export function getAppLocationHref() {
    return isBrowserEnv() && !isEmpty(window?.location?.href) ? window.location.href : "";
}

export const sendErrorBoundaryEvent = (
    error?: Error,
    errorInfo?: ErrorInfo,
    headers?: Record<string, string | undefined> | void,
) => {
    const swgyHeaders = headers ? filterHeaders(headers) : {};
    const errorBoundaryEvents = getNRErrorInfo(error, errorInfo);
    Blaze.recordCustomEvent({
        eventType: "webview_error_boundary",
        appName: "portal_gamification_frontend",
        ...errorBoundaryEvents,
        ...swgyHeaders,
    });
};
